const USER_SUCCESS = 'auth/USER_SUCCESS'
const USER_ERROR = 'auth/USER_ERROR'

const AUTH_REQUEST = 'auth/AUTH_REQUEST'
const AUTH_SUCCESS = 'auth/AUTH_SUCCESS'
const AUTH_ERROR = 'auth/AUTH_ERROR'
const AUTH_LOGOUT = 'auth/AUTH_LOGOUT'

const RESET_AUTH = 'auth/RESET_AUTH'

export { AUTH_REQUEST, AUTH_LOGOUT, AUTH_ERROR, AUTH_SUCCESS, USER_SUCCESS, USER_ERROR, RESET_AUTH }